var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelehoneRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "800px",
    height: "800px",
    viewBox: "-1 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.5a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-6.479-1.112 3.596-2.077-.127-.22a1.85 1.85 0 0 0-2.07-.784 12.23 12.23 0 0 0-4.47 1.591 12.247 12.247 0 0 0-3.595 3.056 1.857 1.857 0 0 0-.381 2.211l.127.22 3.596-2.076-.127-.221a1.62 1.62 0 0 0-.573-.58A12.477 12.477 0 0 1 9.679 7.38a1.616 1.616 0 0 0 .215.787zm-2.749 2.916-.175-.303-3.595 2.077.175.304a.462.462 0 0 0 .629.168l2.798-1.616a.462.462 0 0 0 .168-.63zm6.92-3.997-.175-.303-3.595 2.077.175.303a.462.462 0 0 0 .63.168l2.797-1.616a.462.462 0 0 0 .168-.63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelehoneRound);
export default __webpack_public_path__ + "static/media/telehoneRound.970c731730bc237a4c72b48f0d128425.svg";
export { ForwardRef as ReactComponent };